import { createBaseResourceActions } from '../create-base-resource-actions';
import { OrderStatusResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[ORDER STATUS]';
export const orderStatusActions =
  createBaseResourceActions<OrderStatusResourceTypeMappings>(domainSlug);
